import React, { useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import { getUserApi, setObservacionUserApi } from "../../../services/User/user";

import { useFormik } from "formik";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { ControlPointDuplicateRounded } from "@mui/icons-material/ControlPointDuplicateRounded";

export default function MyAccountClient() {
    const { auth } = useAuth()
    const role = auth ? auth.primaryUser.role : null
    const { logout } = useAuth()
    const [loading, setLoading] = useState(true)
    const [userData, setUserData] = useState(null)
    const [filteredRegions, setFilteredRegions] = useState([])
    const [filteredMunicipalities, setFilteredMunicipalities] = useState([])

    const [initialValues, setInitialValues] = useState(defaultValues())
    const [msgSuccess, setMsgSuccess] = useState(false);
    const [msgDanger, setMsgDanger] = useState(null);

    function defaultValues() {
        return {
            observaciones: "",
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: async (formData) => {
            setMsgSuccess(false);
            setMsgDanger(null)

            let id = userData.id

            let sendData = {
                ...formData,
                id: id,
            }
        setObservacionUserApi(sendData).then(response => {
            if (response.status) {
                setMsgSuccess(true);
            } else {
                setMsgDanger(response.data.errors);
            }
            }).catch(error => {
                console.error(error)
            })
        },
    })


    // Llamamos a la API para obtener los datos del usuario
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        getClient()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getClient = async () => {
        getUserApi({ id: auth.primaryUser.idUser }).then(response => {
            if (response.status) {
                // Keep raw zone if provided (backend may return either `zone` or separate `regions`/`municipalities` arrays)
                setUserData({ id: response.data.data.id, email: response.data.data.email, phone: response.data.data.phone, info: response.data.data.info, service: response.data.data.service, zone: response.data.data.zone || [], observaciones: response.data.data.observaciones})

                // Build regions list from either `zone` or `regions` payloads and deduplicate by id
                let regionsList = [];
                if (response.data.data.zone && Array.isArray(response.data.data.zone)) {
                    regionsList = response.data.data.zone
                        .filter(o => o.idRegion)
                        .map(o => ({ id: o.idRegion, nameRegion: o.nameRegion }));
                } else if (response.data.data.regions && Array.isArray(response.data.data.regions)) {
                    regionsList = response.data.data.regions.map(r => ({ id: r.id, nameRegion: r.name }));
                }
                // unique by id
                const uniqRegions = [];
                const seenRegion = new Set();
                regionsList.forEach(r => {
                    if (r.id && !seenRegion.has(r.id)) {
                        seenRegion.add(r.id);
                        uniqRegions.push(r);
                    }
                });
                setFilteredRegions(uniqRegions);

                // Build municipalities list from either `zone` or `municipalities` payloads and deduplicate by id
                let municipalitiesList = [];
                if (response.data.data.zone && Array.isArray(response.data.data.zone)) {
                    municipalitiesList = response.data.data.zone
                        .filter(o => o.idMunicipality)
                        .map(o => ({ id: o.idMunicipality, nameMunicipy: o.nameMunicipy }));
                } else if (response.data.data.municipalities && Array.isArray(response.data.data.municipalities)) {
                    municipalitiesList = response.data.data.municipalities.map(m => ({ id: m.id, nameMunicipy: m.name }));
                }
                const uniqMun = [];
                const seenMun = new Set();
                municipalitiesList.forEach(m => {
                    if (m.id && !seenMun.has(m.id)) {
                        seenMun.add(m.id);
                        uniqMun.push(m);
                    }
                });
                setFilteredMunicipalities(uniqMun);
                setInitialValues({
                    observaciones: response.data.data.observaciones
                })
            }
            setLoading(false)
        }).catch(error => {
            console.error(error)
            setLoading(false)
        })
    }
    
    
    if (loading) return "";

    return (
        <div className="col-lg-9">
            <div className="card mb-3 mb-lg-5">
                <div className="card-header">
                    <h5 className="card-header-title">
                        Datos Personales
                    </h5>
                </div>

                <div className="card-body">
                    <div className="row mb-4">
                        <label htmlFor="firstNameLabel" className="col-sm-3 col-form-label form-label">Nombre completo</label>

                        <div className="col-sm-9">
                            <div className="input-group">
                                <input type="text" className="form-control" name="firstName" id="firstNameLabel" placeholder={auth.primaryUser.name} aria-label={auth.primaryUser.name} value={auth.primaryUser.name} disabled />
                                <input type="text" className="form-control" name="lastName" id="lastNameLabel" placeholder={auth.primaryUser.surnames} aria-label={auth.primaryUser.surnames} value={auth.primaryUser.surnames} disabled />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <label htmlFor="emailLabel" className="col-sm-3 col-form-label form-label">Email</label>

                        <div className="col-sm-9">
                            <input type="email" className="form-control" name="email" id="emailLabel" placeholder={userData?.email} aria-label={userData?.email} value={userData?.email} disabled />
                        </div>
                    </div>
                    <div className="row mb-4">
                        <label htmlFor="emailLabel" className="col-sm-3 col-form-label form-label">Teléfono</label>

                        <div className="col-sm-9">
                            <input type="email" className="form-control" name="email" id="phoneLabel" placeholder={userData?.phone} aria-label={userData?.phone} value={userData?.phone} disabled />
                        </div>
                    </div>
                    <div className="row mb-4">
                        <label htmlFor="info" className="col-sm-3 col-form-label form-label" >{role == "ROLE_CLIENT" ? "Dirección" : "Observaciones"}</label>

                        <div className="col-sm-9">
                            <div className="input-group">
                                <textarea className="form-control" name="info" id="info" style={{ resize: "none", }} value={userData?.info} disabled></textarea>
                            </div>
                        </div>
                    </div>
                
                    <div className="row mb-4">
                        <label htmlFor="serviceLabel" className="col-sm-3 col-form-label form-label">Servicios {role == "ROLE_CLIENT" ? "contratados" : "asignados"}</label>

                        <ul className="col-sm-9 col-form-label">
                            {userData?.service?.map(service => <li key={"s"+service.id}>{service.name}</li>)}
                        </ul>
                    </div>

                    <div className="row mb-4">
                        <label htmlFor="zoneLabel" className="col-sm-3 col-form-label form-label">Zonas de trabajo Comarca</label>
                        <ul className="col-sm-9 col-form-label">
                            {filteredRegions.map(filReg => <li key={"fR"+filReg.id}>{filReg.nameRegion}</li>)}
                        </ul>

                    </div>
                    <div className="row mb-4">
                        <label htmlFor="zoneLabel" className="col-sm-3 col-form-label form-label">Zonas de trabajo Población</label>

                        <ul className="col-sm-9 col-form-label">
                            {filteredMunicipalities.map(filMun => <li key={"fM"+filMun.id}>{filMun.nameMunicipy}</li>)}
                        </ul>
                    </div>

                    <form onSubmit={formik.handleSubmit}>
                        {msgSuccess && (
                           
                                <div className="alert-success">
                                    La observación se han guardado correctamente
                                </div>

                        )}

                        {msgDanger && (
                           
                                <div className="alert-danger">
                                    {msgDanger.map((item,index) => {
                                        return (<span key={index}>{item} <br /></span>)
                                    })}
                                </div>
                           
                        )}
                        <div className="row mb-4 px-3">
                            <TextField
                                name="observaciones"
                                label="Observaciones"
                                multiline
                                rows={3}
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={formik.values.observaciones}
                                onChange={formik.handleChange}
                            />
                            <div className="col-md-4 offset-md-4 mt-4 text-center">
                                <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                            // fullWidth
                            >
                            Enviar Observación
                            </Button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    )
}